import 'core-js/stable';
import 'regenerator-runtime/runtime';
import svg4everybody from 'svg4everybody';
import objectFitImages from 'object-fit-images';
import AOS from 'aos';

import Hamburger from './components/Hamburger';
import NavMain from './components/NavMain';
import Header from './components/Header';
import AnnouncementBar from './components/AnnouncementBar';
import Hero from './components/Hero';
import ContentPreview from './components/ContentPreview';
import BlockLink from './components/BlockLink';
import TicketPrice from './components/TicketPrice';
import ValidateTickets21 from './components/ValidateTickets21';
import ValidateDeliveryDateChange from './components/ValidateDeliveryDateChange';
import TicketPreview from './components/TicketPreview';
import TicketText from './components/TicketText';
import Maps from './components/Map';
import ToggleProductDescription from './components/ToggleProductDescription';
import Account from './components/Account';

svg4everybody();
objectFitImages();
AOS.init();

AnnouncementBar.init();
Hamburger.init();
NavMain.init();
Header.init();
ContentPreview.init();
Hero.init();
BlockLink.init();
TicketPrice.init();
ValidateTickets21.init();
ValidateDeliveryDateChange.init();
TicketPreview.init();
TicketText.init();
Maps.init();
ToggleProductDescription.init();
Account.init();
